import { Button, Dialog, DialogTitle, Divider, Paper, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";

interface CreatedItem {
  id: string | number;
  name: string;
  description: string;
}

interface Props {
  openModal: boolean;
  handleCloseModal: () => void;
  typeLabel: string; // "Configs" | "Maps"
  items: CreatedItem[];
  isDuplicate?: boolean;
}

const FamilyCreatedConfirmationModal = ({
  openModal,
  typeLabel,
  items,
  isDuplicate,
  handleCloseModal,
}: Props) => {
  return (
    <Dialog
      open={openModal}
      PaperProps={{
        sx: { width: "464px", maxWidth: "464px", zIndex: 99999 },
      }}
    >
      <Paper sx={{ padding: "16px 24px 20px 24px" }}>
        <DialogTitle sx={{ padding: "0px 0px 4px 0px" }}>
          {isDuplicate ? "Family Duplicated" : "New Family Created"}
        </DialogTitle>

        <Box
          mt={2}
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography sx={{ fontSize: 12, color: "#00000099", textTransform: "uppercase" }}>
            {typeLabel}
          </Typography>
          <Typography sx={{ fontSize: 12, color: "#00000099" }}>{items.length}</Typography>
        </Box>
        <Divider sx={{ mt: 0.5, mb: 1 }} />

        {items.length === 0 ? (
          <Typography sx={{ fontSize: 13, color: "#00000099", py: 1 }}>
            No {typeLabel.toLowerCase()} attached — connect some now or later.
          </Typography>
        ) : (
          <Stack spacing={1}>
            {items.map((item) => (
              <Box
                key={item.id}
                sx={{ border: "1px solid #0000001F", borderRadius: "8px", p: 1 }}
              >
                <Typography sx={{ color: "#9C27B0", fontSize: 14, fontWeight: 500 }}>
                  {item.name}{" "}
                  <Box component="span" sx={{ color: "#00000061", fontSize: 12, fontWeight: 500 }}>
                    ({item.id})
                  </Box>
                </Typography>
                <Typography sx={{ color: "#00000099", fontSize: 12 }}>
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Stack>
        )}

        <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
          <Button variant="text" color="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Stack>
      </Paper>
    </Dialog>
  );
};

export default FamilyCreatedConfirmationModal;
